import React, { useContext, useMemo } from 'react';
import useCommonStyles from '../../../../../commonStyles';
import ModalAddNewInventoryValue from './ModalAddNewInventoryValue';
import ModalTpVastTags from './ModalTpVastTags';
import FormControl from '@mui/material/FormControl';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import { Modalv2Context } from '../../../../../Contexts/Modalv2Context';
import { TPVAST_CONSTANTS } from '../../../../../core/constants';

/**
 * @name InventoryList  The function `InventoryList` renders available tpVastConfiguration.
 */
const InventoryList = ({
	inventoryType,
	tpVastDoc,
	updateTpVastDoc,
	selectedTpValues,
	setSelectedTpValues,
	updateSelectedTpValues
}) => {
	const commonStyleClasses = useCommonStyles();
	const { updateModalContent } = useContext(Modalv2Context);
	const { FLOOR, DEMAND, PLATFORM } = TPVAST_CONSTANTS.INVENTORY;
	const inventoryObject = useMemo(() => {
		if (inventoryType === FLOOR) {
			return tpVastDoc;
		}
		if (inventoryType === DEMAND) {
			return tpVastDoc[selectedTpValues[FLOOR]] || {};
		}
		if (inventoryType === PLATFORM) {
			return tpVastDoc[selectedTpValues[FLOOR]]?.[selectedTpValues[DEMAND]] || {};
		}
		return {};
	}, [inventoryType, tpVastDoc, selectedTpValues]);

	/**
	 * @name deleteInventory  The function `deleteInventory` deletes a particular inventory value from the config
	 * @param {String} inventoryType Type of inventory. For ex :- floor, demand and platform
	 * @param {String} inventoryValue Value to be deleted, this value will be deleted from the config with its nesting.
	 */
	function deleteInventory(inventoryType, inventoryValue) {
		let newObj = structuredClone(tpVastDoc);
		if (inventoryType === FLOOR) {
			delete newObj[inventoryValue];
		}
		if (inventoryType === DEMAND) {
			delete newObj[selectedTpValues[FLOOR]][inventoryValue];
		}
		if (inventoryType === PLATFORM) {
			delete newObj[selectedTpValues[FLOOR]][selectedTpValues[DEMAND]][inventoryValue];
		}
		if (selectedTpValues[inventoryType] === inventoryValue) {
			const clonedSelectedTpvValues = structuredClone(selectedTpValues);
			clonedSelectedTpvValues[inventoryType] = '';
			updateSelectedTpValues(inventoryType, '');
		}
		updateTpVastDoc(newObj);
	}

	return (
		<div>
			<FormControl fullWidth style={{ margin: '2rem 0' }}>
				<List
					sx={{
						width: '100%',
						maxWidth: 360,
						border: '2px solid darkgrey',
						borderRadius: '0.5rem',
						bgcolor: 'background.paper',
						position: 'relative',
						overflow: 'auto',
						height: 350,
						'& ul': { padding: 0 }
					}}
				>
					{Object.keys(inventoryObject).map((inventoryValue, index) => {
						if (inventoryType === FLOOR && inventoryValue === 'dateCreated') {
							return null;
						}
						return (
							<ListItem
								key={inventoryValue}
								style={{ backgroundColor: index % 2 === 1 ? '#ffe6e8' : 'white' }}
							>
								<ListItemButton
									onClick={() => {
										updateSelectedTpValues(inventoryType, inventoryValue);
										if (inventoryType === PLATFORM)
											updateModalContent(
												<ModalTpVastTags
													key={inventoryType}
													selectedFloor={selectedTpValues[FLOOR]}
													selectedDemand={selectedTpValues[DEMAND]}
													selectedPlatform={inventoryValue}
													tpVastDoc={structuredClone(tpVastDoc)}
													updateTpVastDoc={updateTpVastDoc}
													setSelectedTpValues={setSelectedTpValues}
												/>
											);
									}}
								>
									<ListItemText primary={inventoryValue} />
									{selectedTpValues[inventoryType] === inventoryValue && (
										<CheckCircleIcon color="primary" />
									)}
								</ListItemButton>
								<DeleteIcon
									color="primary"
									fontSize="small"
									className={commonStyleClasses.icon}
									style={{ margin: '0' }}
									onClick={() => deleteInventory(inventoryType, inventoryValue)}
								/>
							</ListItem>
						);
					})}
				</List>
			</FormControl>
			<AddCircleOutlineOutlinedIcon
				className={commonStyleClasses.icon}
				style={{ margin: '1rem 45%' }}
				color="primary"
				fontSize="large"
				onClick={() => {
					updateModalContent(
						<ModalAddNewInventoryValue
							inventoryType={inventoryType}
							tpVastDoc={structuredClone(tpVastDoc)}
							updateTpVastDoc={updateTpVastDoc}
							selectedTpValues={selectedTpValues}
						/>
					);
				}}
			/>
		</div>
	);
};

export default InventoryList;
